<template>
    <div class="dashboard-box card-box-wide text-center  border-radius-8 p-4">
        <div class="card-grid h-100">
            <div class="image-section d-flex justify-content-center items-center">
                <img :src="imageUrl"
                     :alt="imageAlt"
                     class="wide-card-img">
            </div>
            <div class="content-section">
                <h5 class="color-blue font-poppins font-weight-semibold my-3">
                    {{ title }}
                </h5>
                <p v-if="details" class="font-poppins font-weight-light color-dark-blue">
                    {{ details }}
                </p>
                <div class="w-100 md:w-50 mx-auto d-flex align-bottom my-4">
                    <a :href="buttonUrl"
                       class="btn bg-fire-orange color-white font-poppins font-weight-bolder w-100  radius-19">
                        {{ buttonLabel }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: null
        },

        details: {
            type: String,
            default: null
        },
        buttonUrl: {
            type: String,
            default: ''
        },
        buttonLabel: {
            type: String,
            default: ''
        },
        imageUrl: {
            type: String,
            default: ''
        },
        imageAlt: {
            type: String,
            default: ''
        }
    }
}
</script>
